import { EdgeGetConnectEulaStatusRepository } from '@/modules/connect/infra'
import type { GetConnectEulaStatus } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeGetConnectEulaStatus(): GetConnectEulaStatus {
  return new EdgeGetConnectEulaStatusRepository(makeSupabaseEdgeHttpClient()).execute
}
